export const colors = {
  primary: '#1E90FF',  // Blue
  secondary: '#32CD32', // Green
  background: '#FFFFFF', // White
  text: '#000000', // Black
  textSecondary: '#2F4F4F', // Dark Gray
  highlight: '#00CED1', // Teal
  accent: '#FFD700', // Yellow
};
